

export class MobileAppHelper {

  static isApp() {    
    return document.body.classList.contains('mobile-app') && !!MobileAppHelper.messageBase();
  }

  static messageBase() {
    return window.ReactNativeWebView;
  }

  static updateShoppingCartCount(count) {
    if (MobileAppHelper.isApp()) {
      const event = {
        event_type: 'shoppingcart_contents',
        timestamp: new Date(),
        payload: {
          count: count ? parseInt(count, 0) : 0,
        },
      };
      MobileAppHelper.messageBase().postMessage(JSON.stringify(event));
    }
  }

  static updateRouting(route, isTopLevelPage, title) {
    if (MobileAppHelper.isApp()) {
      const event = {
        event_type: 'route_change',
        timestamp: new Date(),
        payload: {
          route: route, // home, collection, marketplace, shopping_cart, user
          is_top_level: isTopLevelPage, // e.g. true for root pages of 'home', 'marketplace', etc, false for all subpages,
          title: title,
        },
      };
      MobileAppHelper.messageBase().postMessage(JSON.stringify(event));
    }
  }
  
  static updateLoginStatus(avatarUrl) {
    if (MobileAppHelper.isApp()) {
      const event = {
        event_type: 'authentication_status',
        timestamp: new Date(),
        payload: {
          is_logged_in: !!avatarUrl,
          avatar_url: avatarUrl,
        },
      }
      MobileAppHelper.messageBase().postMessage(JSON.stringify(event));
    }
  }

}
